import { UiTourRegistry } from '@booking-booster-client/models';
import { StatisticsKeywordsTour } from './statistics-keywords/statistics-keywords-tour.config';
import { AdsTour } from './ads/ads-tour.config';
import { PropertyDetailTour } from './property-detail/property-detail-tour.config';
import { PropertiesTour } from './properties/properties-tour.config';
import { SettingsRbaUsersTour } from './settings-rba-users/settings-rba-users-tour.config';
import { SettingsAdvertisersTour } from './settings-advertisers/settings-advertisers-tour.config';
import { SettingsBalanceTour } from './settings-balance/settings-balance-tour.config';
import { SettingsAccountingTour } from './settings-accounting/settings-accounting-tour.config';
import { SettingsAdvertisersDetailTour } from './settings-advertisers-detail/settings-advertisers-detail-tour.config';
import { SettingsAdvertisersParametersTour } from './settings-advertisers-parameters/settings-advertisers-parameters-tour.config';
import { StatisticsCampaignsTour } from './statistics-campaigns/statistics-campaigns-tour.config';

export const TourRegistryMap: UiTourRegistry = {
  'statistics-keywords': StatisticsCampaignsTour,
  'statistics-campaigns': StatisticsKeywordsTour,
  ads: AdsTour,
  properties: PropertiesTour,
  'property-detail': PropertyDetailTour,
  'settings-rba-users': SettingsRbaUsersTour,
  'settings-advertisers': SettingsAdvertisersTour,
  'settings-advertisers-detail': SettingsAdvertisersDetailTour,
  'settings-advertisers-parameters': SettingsAdvertisersParametersTour,
  'settings-balance': SettingsBalanceTour,
  'settings-accounting': SettingsAccountingTour,
};
